import { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { RegistrationContext } from '../../../context/registration';
import { useToasts } from 'react-toast-notifications';

import { TextInput, SelectInput } from '~/shared/components/form/Inputs';
import { ProgressBar } from '../ProgressBar';
import { identityOptions } from '~/shared/config';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    Form,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';

import { agreementClauseOptions } from '~/shared/agreements';
// import { fetchAgreementTerms } from '~/services/options';
import { setAgreementClauses } from '~/services/registration';
import { Loading } from '../../../shared/components/Loading';
import moment from 'moment';

interface ClauseOption {
    id: number;
    name: string;
    description: string;
    agree: boolean;
}

export const Agreements = ({}: any) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [signature, setSignature] = useState('');
    const [{ campaignRequest }, registrationDispatch] =
        useContext(RegistrationContext);
    const [clauseOptions, setClauseOptions] = useState<ClauseOption[]>([]);
    const { addToast } = useToasts();
    const history = useHistory();
    const today = moment().format('Y-MM-DD');
    const {
        register,
        handleSubmit,
        watch,
        control,
        reset,
        setValue,
        getValues,
        formState: { errors, isSubmitting, isValid },
    } = useForm({
        ag_certify_identity: '',
        ag_signature: '',
        ag_signature_date: '',
    });

    // const getAgreementTerms = async () => {
    //   const resp = await fetchAgreementTerms();
    //   const opts = resp.map((opt) => {
    //     return {
    //       id: opt.id,
    //       name: opt.name,
    //       description: opt.template,
    //       agree: false,
    //     };
    //   });
    //   setClauseOptions(opts);

    //   // Additionally get identity options

    //   setLoading(false);
    // };

    useEffect(() => {
        // getAgreementTerms();
        const opts = agreementClauseOptions.map((opt) => {
            return {
                ...opt,
                agree: false,
            };
        });
        setClauseOptions(opts);
        setValue('ag_signature_date', today);
        setLoading(false);
    }, []);

    const disableAgree = (i) => {
        if (i === 0) {
            return false;
        }
        const prevOpt = clauseOptions[i - 1];
        if (prevOpt.agree) {
            return false;
        }
        return true;
    };

    const handleNext = async (data) => {
        try {
            setSaving(true);
            // const agreement_clause_ids = clauseOptions.map((x) => x.id);
            const resp = await setAgreementClauses({
                clause_options: clauseOptions,
                ...data,
            });
            registrationDispatch({
                type: 'set_application',
                application: resp,
            });

            history.push('/get-started/continue');
        } catch (e) {
            setSaving(false);
            console.log('e: ', e);
        }
    };

    const handleCheck = (i) => {
        let newOpts = [...clauseOptions];
        newOpts[i]['agree'] = !newOpts[i]['agree'];
        setClauseOptions(newOpts);
    };

    if (loading) {
        return <Loading />;
    }

    const disableNext = clauseOptions.filter((x) => !x.agree).length > 0;

    return (
        <Container>
            <ProgressBar selectedStep='agreements' />

            <Form onSubmit={handleSubmit(handleNext)}>
                <Row className='justify-content-center py-5'>
                    <Col md='7'>
                        <div className='text-center'>
                            <h3>
                                Lastly, we need you to agree to a few things
                                before starting a campaign
                            </h3>
                            <p>Please review and check all agreements below.</p>
                        </div>

                        <Card
                            className='box-shadow my-5'
                            style={{
                                maxWidth: '900px',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        >
                            <CardBody>
                                {clauseOptions.map((clause, i) => {
                                    const disabled = disableAgree(i);
                                    return (
                                        <FormGroup key={i}>
                                            <h2>{i + 1}</h2>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: clause.label,
                                                }}
                                            ></p>
                                            <Label check>
                                                <Input
                                                    id={`clause-${i}`}
                                                    type='checkbox'
                                                    onChange={() =>
                                                        handleCheck(i)
                                                    }
                                                    name={`clause-${i}`}
                                                    disabled={disabled}
                                                />
                                                {disabled
                                                    ? ` You need to accept the prior terms first`
                                                    : ` I accept`}
                                            </Label>
                                        </FormGroup>
                                    );
                                })}
                                <hr />
                                {/* <FormGroup>
                  <Label>Name of individual saving these agreements *</Label>
                  <Input
                    name='signature_name'
                    onChange={(e) => setSignature(e.target.value)}
                    required={true}
                    ariaRequired={true}
                  />
                </FormGroup> */}

                                <SelectInput
                                    control={control}
                                    required={true}
                                    ariaRequired={true}
                                    name='ag_certify_identity'
                                    label='I certify that I am the:'
                                    defaultLabel='Select'
                                    options={identityOptions}
                                    errors={
                                        errors?.ag_certify_identity?.message
                                    }
                                />

                                <Row>
                                    <Col>
                                        <TextInput
                                            name='ag_signature'
                                            label='Name of individual saving these agreements'
                                            control={control}
                                            errors={
                                                errors?.ag_signature?.message
                                            }
                                            required={true}
                                            ariaRequired={true}
                                        />
                                    </Col>
                                    <Col>
                                        <TextInput
                                            name='ag_signature_date'
                                            label='Date'
                                            control={control}
                                            type='date'
                                            errors={
                                                errors?.ag_signature_date
                                                    ?.message
                                            }
                                            required={true}
                                            ariaRequired={true}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <div className='text-center mb-5'>
                    <Button
                        color='primary'
                        // onClick={handleNext}
                        type='submit'
                        disabled={saving || disableNext || !isValid}
                    >
                        {saving ? `Saving...` : `Next`}
                    </Button>
                </div>
            </Form>
        </Container>
    );
};
